import { useState } from "react"
import AboutTab from "../tabs/about"
import EditProfileTab from "../tabs/editptofile"
import ProfileHeader from "./profile-header"
import ProfileTabs from "./profile-tabs"
import UpdatePassword from "./update-passwrord"
import { GoogleAd } from "../ads/GoogleAd"
import { useScreen } from "../../contexts/screen.provider"

export default function Profile() {
  const { isMobile } = useScreen();

  const [activeTab, setActiveTab] = useState("about")

  return (
    <div className="h-full w-full py-4   bg-white dark:bg-[#202020]">
      <div className="w-full  mx-auto">

        <div className="flex flex-col gap-2 py-2  w-full lg:flex-row">
          {/* Left Column (Profile Header) */}
          <div className="w-full lg:w-1/2  lg:mb-0">
            <ProfileHeader />
          </div>
          {
            isMobile && <GoogleAd />
          }
          {/* Right Column (Tabs and Content) */}
          <div className="w-full  dark:bg-[#262626] bg-white shadow-md flex flex-col justify-stretch lg:w-1/2 ">
            <div className="rounded-lg flex flex-col items-center  h-[99%]    justify-stretch  ">
              {/* Navigation Tabs */}
              <ProfileTabs activeTab={activeTab} setActiveTab={setActiveTab} />

              {/* Tab Content */}
              <div className=" flex w-full  justify-stretch p-2 md:p-2 flex-col">
                {activeTab === "about" && <AboutTab />}
                {activeTab === "edit" && <EditProfileTab setActiveTab={setActiveTab} />}
                {activeTab === "updatePassword" && <UpdatePassword setActiveTab={setActiveTab} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
